/* eslint-disable react/react-in-jsx-scope */

export const SIZE_LIMIT_DESK = 980;
export const SIZE_LIMIT_TABLET = 500;
export const MOBILE = "mobile";
export const DESK = "desk";
export const TABLET = "tablet";
